import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Slider_Big() {
  function CustomNextArrow(props) {
    const { onClick } = props;return (<div className="neelan-next neelan-arrow" onClick={onClick}><img src="img/btn-next.svg" alt="Next" width='50px' /></div>);
  }
  function CustomPrevArrow(props) {
    const { onClick } = props;return (<div className="neelan-prev neelan-arrow" onClick={onClick}><img src="img/btn-prev.svg" alt="Next" width='50px' /></div>);
  }
  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 3000,
    cssEase: "linear",
    nextArrow:<CustomNextArrow />,
    prevArrow:<CustomPrevArrow />,
  };
  return (
    <div className="slider-container neel-slider neel-slider-lg">
      <Slider {...settings}>
        <div><img src="/img/carousel/a1.jpg" className="img-fluid" /></div>
        <div><img src="/img/carousel/a2.jpg" className="img-fluid" /></div>
        <div><img src="/img/carousel/a3.jpg" className="img-fluid" /></div>
        <div><img src="/img/carousel/a4.jpg" className="img-fluid" /></div>
        <div><img src="/img/carousel/a5.jpg" className="img-fluid" /></div>            
      </Slider>
    </div>
  );
}
export default Slider_Big;